import { CopyConfirmDialogResultData } from "./../../../core/models/dialogs/confirm-dialog-data";
import { Component, OnInit, Inject } from "@angular/core";
import { ConfirmDialog } from "../confirm/confirm.component";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { ConfirmDialogData } from "../../../core/models/dialogs/confirm-dialog-data";
import { UntypedFormBuilder, Validators, UntypedFormGroup } from "@angular/forms";

@Component({
  selector: "confirm-copy-options",
  templateUrl: "./confirm-copy-options.component.html",
  styleUrls: ["./confirm-copy-options.component.scss"]
})
export class ConfirmCopyOptionsComponent implements OnInit {
  public confirmForm: UntypedFormGroup;
  public submitted: boolean;

  public readonly minCopies: number = 1;
  public readonly maxCopies: number = 200;

  constructor(
    public dialogRef: MatDialogRef<ConfirmDialog>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData,
    public fb: UntypedFormBuilder
  ) { }

  public ngOnInit() {
    this.createForm();
  }

  private createForm() {
    this.confirmForm = this.fb.group({
      copyCount: [
        1,
        [
          Validators.required,
          Validators.min(this.minCopies),
          Validators.max(this.maxCopies)
        ]
      ]
    });
  }

  public confirmCopy() {
    this.submitted = true;
    if (!this.confirmForm.valid) {
      return;
    }

    const dialogResult: CopyConfirmDialogResultData = {
      isConfirmed: true,
      copyCount: this.confirmForm.value.copyCount
    };

    this.dialogRef.close(dialogResult);
  }

  public cancel() {
    const dialogResult: CopyConfirmDialogResultData = {
      isConfirmed: false
    };

    this.dialogRef.close(dialogResult);
  }
}
